/*
 * 功能：webscoket连接
 * 作者：kiscon
 * 日期：2019-09-22
 * 说明：消息类型：10|xxxx 表示心跳、11|xxxx 位置信息、7|xxxx 下发拍照命令
 * */

/**
 * webSocket的readyState属性用来定义连接状态，该属性的值有下面几种：
 * 0 ：对应常量CONNECTING (numeric value 0)，
 * 正在建立连接连接，还没有完成。The connection has not yet been established.
 * 1 ：对应常量OPEN (numeric value 1)，
 * 连接成功建立，可以进行通信。The WebSocket connection is established and communication is possible.
 * 2 ：对应常量CLOSING (numeric value 2)
 * 连接正在进行关闭握手，即将关闭。The connection is going through the closing handshake.
 * 3 : 对应常量CLOSED (numeric value 3)
 * 连接已经关闭或者根本没有建立。The connection has been closed or could not be opened.
 **/

/* global MozWebSocket */

// 记录重连次数
function reportReconnectLog() {
  try {
    const logKey = 'VMS_WEBSOCKET_RECONNECT_LOG'
    let logContent = window.localStorage.getItem(logKey)
    if (logContent) {
      logContent = JSON.parse(logContent)
    } else {
      logContent = {
        startTime: new Date().toString(),
        count: 0
      }
    }
    logContent.count++
    window.localStorage.setItem(logKey, JSON.stringify(logContent))
  } catch (ex) {
    console.log(ex)
  }
}

export async function socketIo(socketUrl) {
  let ws = null
  let lockSocket = false
  let pingTimer = null
  let reconnecTimer = null
  let timeout = 40000
  let listener = {}
  let paramsObj = {}
  let hasParams = false

  // 重连机制
  const reconnect = socketUrl => {
    if (!lockSocket) return
    if (reconnecTimer) clearTimeout(reconnecTimer)
    lockSocket = true
    reconnecTimer = setTimeout(() => {
      createSocket(socketUrl)
      reportReconnectLog()
    }, 10000)
  }

  // 发送数据
  const sendMessage = data => {
    if (ws && ws.readyState === 1) {
      ws.send(data)
    }
  }

  // 发送心跳
  const sendPing = () => {
    pingTimer = setInterval(() => {
      let msg = '10|30'
      sendMessage(msg)
    }, timeout)
  }

  // 初始事件
  const initEvents = () => {
    ws.onopen = () => {
      console.log('---socket已连接---')
      lockSocket = false
      pingTimer && clearInterval(pingTimer)
      sendPing()
      if (ws.readyState === 1) {
        if (hasParams) {
          for (let k in paramsObj) {
            let property = {}
            let arr = []
            let item = paramsObj[k]
            for (let i = 0; i < item.length; i++) {
              let el = item[i]
              let ele = el && el.split(',')
              for (let j = 0; j < ele.length; j++) {
                let p = ele[j]
                if (!property[p]) {
                  property[p] = true
                  arr.push(p)
                }
              }
            }
            // console.log(arr)
            sendMessage(`${k}|${arr.join(',')}`)
          }
        }
        // sendData && sendMessage(sendData)
      }
    }
    ws.onmessage = event => {
      let data = event.data
      for (let k in listener) {
        if (typeof listener[k] === 'function') {
          listener[k](data)
        }
      }
    }
    ws.onerror = event => {
      console.log('---socket连接发生错误---')
      pingTimer && clearInterval(pingTimer)
      lockSocket = true
      reconnect(socketUrl)
    }
    ws.onclose = () => {
      console.log('---socket连接关闭---')
      pingTimer && clearInterval(pingTimer)
      lockSocket = true
      reconnect(socketUrl)
      ws.close()
    }
  }

  function createSocket(socketUrl) {
    try {
      if ('WebSocket' in window) {
        ws = new WebSocket(socketUrl)
      } else if ('MozWebSocket' in window) {
        ws = new MozWebSocket(socketUrl)
      }
      initEvents()
    } catch (e) {
      pingTimer && clearInterval(pingTimer)
      lockSocket = true
      reconnect(socketUrl)
    }
  }
  await createSocket(socketUrl) // 创建socket连接

  return new Promise((resolve, reject) => {
    const data = {
      close: () => {
        ws.close()
      },
      addListener: (key, callback) => {
        listener[key] = callback
      },
      send: data => {
        let params = data || ''
        let arr = params.split('|') || []
        let key = arr[0]
        let value = arr[1] || ''
        hasParams = true
        paramsObj[key] = paramsObj[key] || []
        paramsObj[key].push(value)
        sendMessage(data)
      },
      removeListener: key => {
        delete listener[key]
      },
      removeParams(key) {
        delete paramsObj[key]
      }
    }
    resolve(data)
  })
}

class SocketIo {
  constructor() {
    this._socket = {}
  }
}

const socket = new SocketIo()

// 用户id字符串
const getMsgId = id => {
  return id + '_' + new Date().getTime()
}

// 内容字符串
const guid = () => {
  let S4 = function() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }
  return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4()
}

export { getMsgId, guid, socket }



// WEBPACK FOOTER //
// ./src/shared/home-modules/header/socket.js